import { useState } from 'react'
import Button from 'components/Button'
import Modal from 'components/Modal'
import Select from 'components/Select'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectCurrentStudent } from 'modules/students/ducks/selectors'
import { isNotNilOrEmpty } from 'utils/ramda'
import { formatDate, DATE_FORMATS } from 'utils/date'
import { updateStudent } from 'services/StudentsService'
import { updateTeacherResignations } from 'services/TeachersService'
import { v4 as uuidv4 } from 'uuid'
import Checkbox from 'components/Checkbox'
import Input from 'components/Input'

const defaultValues = {
  teacher: null,
  reason: null,
  comment: '',
  oneTime: false
}

const StudentTeachersMarkedToBeDeleted = ({ onChange, marks }) => {
  const student = useSelector(selectCurrentStudent)
  const [isOpen, setIsOpen] = useState(false)
  const [values, setValues] = useState(defaultValues)
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false)
  const [removeId, setRemoveId] = useState(null)
  const [teacherId, setTeacherId] = useState(null)
  const handleChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  const reasonOptions = [
    {
      value: 'failed',
      label: 'Fail'
    },
    {
      value: 'success',
      label: 'Pochwała'
    },
    {
      value: 'teacher_request',
      label: 'Rezygnacja nauczyciela z ucznia'
    },
    {
      value: 'na',
      label: 'N/A'
    },
    {
      value: 'matura',
      label: 'Matura'
    }
  ]

  const handleClose = () => {
    setIsOpen(false)
    setValues(defaultValues)
  }

  console.log({values, student})

  const handleSubmit = () => {
    const id = uuidv4()
    const newResignation = {
      id,
      teacher_id: values.teacher,
      teacher_name: student.teachers.find(teacher => teacher.id === values.teacher).name,
      reason: reasonOptions.find(option => option.value === values.reason).label,
      comment: values.comment,
      one_time: values.oneTime,
      created_at: new Date().toISOString()
    }

    const payload = [...marks, newResignation]

    onChange('toBeDeletedMarks', payload)
    onChange('toBeDeletedToggledBy', 'admin')
    onChange('toBeDeleted', true)

    updateStudent({
      student: {
        ...student,
        toBeDeletedMarks: payload,
        toBeDeletedToggledBy: 'admin',
        toBeDeleted: true
      },
      callback: () => {
        updateTeacherResignations({
          teacherId: values.teacher,
          newResignation: {
            id,
            student_name: student.name,
            student_id: student.id,
            subject: student.teachers.find(teacher => teacher.id === values.teacher).subject,
            reason: reasonOptions.find(option => option.value === values.reason).label,
            comment: values.comment,
            one_time: values.oneTime,
            created_at: new Date().toISOString()
          },
          callback: handleClose
        })
      }
    })

  }

  const handleRemoveResignation = (id) => {
    const payload = marks.filter(mark => mark.id !== id)
    onChange('toBeDeletedMarks', payload)

    updateStudent({
      student: {
        ...student,
        toBeDeletedMarks: payload
      },
      callback: () => {
        updateTeacherResignations({
          teacherId,
          newResignation: { id },
          remove: true,
          callback: handleClose
        })
      }
    })
  }

  return (
    <Wrapper>
      <Button color='primary-outline' onClick={() => setIsOpen(true)}>Dodaj rezygnację</Button>
      {
        isNotNilOrEmpty(marks) && (
          <>
            <h3>Rezygnacja ucznia</h3>
            <Table>
              <thead>
                <tr>
                  <th>Nauczyciel</th>
                  <th>Powód</th>
                  <th>Data</th>
                  <th>Jednorazowy</th>
                  <th>Komentarz</th>
                  <th>Akcja</th>
                </tr>
              </thead>
              <tbody>
                {marks?.map(mark => (
                  <tr key={`${mark.teacher_id}-${mark.created_at}`}>
                    <td>{mark.teacher_name}</td>
                    <td>{mark.reason}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{formatDate(mark.created_at, DATE_FORMATS.exactTime)}</td>
                    <td>{mark.one_time ? 'Tak' : 'Nie'}</td>
                    <td>{mark.comment}</td>
                    <td>
                      <RemoveButton onClick={() => {
                        setRemoveId(mark.id)
                        setTeacherId(mark.teacher_id)
                        setIsRemoveModalOpen(true)
                      }}>Usuń</RemoveButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )
      }

      <Modal
        title='Dodaj rezygnację'
        open={isOpen}
        onClose={handleClose}
      >
        <div>
          <Select
            label='Nauczyciel'
            name='teacher'
            value={values.teacher}
            onChange={handleChange}
            options={student.teachers?.map(teacher => ({
              value: teacher.id,
              label: teacher.name
            }))}
          />
          <Select
            label='Powód usunięcia'
            name='reason'
            value={values.reason}
            onChange={handleChange}
            options={reasonOptions}
          />
          <Input
            label='Komentarz'
            name='comment'
            multiline
            rows={3}
            value={values.comment}
            onChange={handleChange}
          />
          <div style={{ marginTop: '10px' }}>
            <Checkbox
              label='Jednorazowy'
              name='oneTime'
              value={values.oneTime}
              onChange={handleChange}
            />
          </div>
        </div>
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button disabled={!values.teacher || !values.reason} onClick={handleSubmit} color='primary'>Zapisz</Button>
        </ButtonsWrapper>
      </Modal>
      <Modal
        title='Usuń rezygnację'
        open={isRemoveModalOpen}
        onClose={() => setIsRemoveModalOpen(false)}
      >
        <p>Czy na pewno chcesz usunąć rezygnację?</p>
        <ButtonsWrapper>
          <Button onClick={() => setIsRemoveModalOpen(false)} color='secondary'>Anuluj</Button>
          <Button onClick={() => {
            handleRemoveResignation(removeId)
            setRemoveId(null)
            setIsRemoveModalOpen(false)
          }} color='primary'>Usuń</Button>
        </ButtonsWrapper>
      </Modal>
    </Wrapper>
  )
}

export default StudentTeachersMarkedToBeDeleted

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  font-size: 12px;

  td, th {
    padding: 5px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`

const RemoveButton = styled.p`
  cursor: pointer;
`